import { useEffect, useState } from "react";

interface CountDownProps {
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const initialCountDown = {months:0, days: 0, hours: 0, minutes: 0, seconds: 0 };

const getTimeDiff = (aDate: string) => {
  const difference = new Date(aDate).getTime() - new Date().getTime();
  let timeLeft: CountDownProps = initialCountDown;

  if (difference > 0) {
    timeLeft = {
      months: Math.floor(difference / (1000 * 60 * 60 * 24 * 30)),
      days: Math.floor(difference / (1000 * 60 * 60 * 24) % 30),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }
  return timeLeft
}

const useCountDown = (aDate: string) => {
  const [countDown, setCountDown] = useState<CountDownProps>(initialCountDown);
  const [finalCountDown, setFinalCountDown] = useState<boolean>(false);
  let clearCountDown: ReturnType<typeof setTimeout> = setTimeout(() => null, 0);

  const stopCountDown = () => {
    clearTimeout(clearCountDown);
  }

  useEffect(() => {
    clearCountDown = setInterval(()=> {
      const timeDiff = getTimeDiff(aDate);
      if (timeDiff.hours <= 0 && timeDiff.minutes <= 0 && timeDiff.seconds <= 0){
        setCountDown(initialCountDown);
        stopCountDown();
        setFinalCountDown(true);
      } else {
        setCountDown(timeDiff);
      }
    }, 1000);
    return () => clearInterval(clearCountDown);
  }, []);

  return { countDown, finalCountDown, stopCountDown };
};

export default useCountDown;
